import {each} from "jquery";
import {breakpoint} from "../enum/breakpoint";

require("slick-carousel/slick/slick");

let currentIndex = 1;
const DURATION = 7000;

function switchItem(element: HTMLElement | JQuery<HTMLElement>) {
    const $bannerDetail = $(element).next();
    $(".banner-detail").css("z-index", "0");
    $(".banner-active").removeClass("banner-active").children(".banner-detail").css("z-index", "1");
    $(element).parent().toggleClass("banner-active").children(".banner-detail").css("z-index", "2");
    $bannerDetail.css("bottom", "-100vh");
    $bannerDetail.animate({'bottom': '0'}, 700);
    currentIndex++;
}

function slideBanner() {
    let banners = $(".banner-name");
    if (currentIndex >= banners.length) {
        currentIndex = 0;
    }
    switchItem(banners[currentIndex]);
}

function setIndex(element: JQuery<HTMLElement>, $banners: any) {
    for (let i = 0; i < $banners.length; i++) {
        if ($banners[i] === element.get(0)) {
            currentIndex = i;
        }
    }
}

$(() => {
    let $banners = $(".banner-name");


    if ($banners.length !== 0) {
        let autoClick = window.setInterval(slideBanner, DURATION);

        $banners.each(function () {
            $(this).on("click", function () {
                clearInterval(autoClick);
                setIndex($(this), $banners);
                switchItem($(this));
                autoClick = window.setInterval(slideBanner, DURATION);
            });
        });
    }

    const $window = $(window);
    const $slick_slider = $('.banner-carousel');
    const settings = {

            prevArrow: $('.prev'),
            nextArrow: $('.next'),
            centerMode: true,
            centerPadding: '1rem',
            slidesToShow: 2,
            autoplay: true,
            autoplaySpeed: 7000,
            dots: true,
            arrows: true,
            responsive: [
                {
                    breakpoint: breakpoint.tablet,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ],


    };
    if ($(window).width()! < breakpoint.desktop) {
        $slick_slider.slick(settings);
    }

    $window.on('resize', function () {
        if ($window.width()! > breakpoint.desktop) {
            if ($slick_slider.hasClass('slick-initialized')) {
                $slick_slider.slick('unslick');
            }
            return
        }
        if (!$slick_slider.hasClass('slick-initialized')) {
            return $slick_slider.slick(settings);
        }
        return;
    });
});